import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as labelTranslations } from '../../i18n/show-password/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

export type ShowPasswordIconButtonProps = LocalizedIconButtonProps & {
  passwordVisible: boolean;
};

/**
 * A button to toggle password visibility.
 * Always uses the label "Show password".
 * Icon and aria-pressed reflect the passwordVisible prop.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export const ShowPasswordIconButton = ({
  passwordVisible,
  ...props
}: ShowPasswordIconButtonProps) => {
  const label = useLocalizedString(labelTranslations);
  return (
    <IconButton
      icon={passwordVisible ? 'eye' : 'eye-slashed'}
      aria-label={label}
      aria-pressed={passwordVisible}
      {...props}
    />
  );
};
